/* eslint-disable react/prop-types */

import React, { useContext } from "react";
import { graphql, StaticQuery } from "gatsby";
import { AppContext } from "~context/AppContext";
import { DocumentContext } from "~context/DocumentContext";
import Cross from "~components/svg/Cross";

const query = graphql`
  query Notification {
    sanityNotification {
      text
    }
  }
`;

const Notification = () => {
  const { notificationActive, setNotificationActive, freenoticeActive, setFreenoticeActive, cartTotal, setCartActive } = useContext(AppContext);
  const { device } = useContext(DocumentContext);

  //

  return (
    <StaticQuery
      query={query}
      render={data => {
        let notificationText = data?.sanityNotification?.text;
        let freeshipping = 60;
        //console.log(process.env.GATSBY_REGION_CODE);
        if(process.env.GATSBY_REGION_CODE == `uk`){
          freeshipping = 50;
          notificationText = "Free Shipping On Orders Over £50";
        }
        let helloText = notificationText;
        if (cartTotal <= 0){
          helloText = notificationText;
        }else if (cartTotal >= freeshipping) {
          helloText = "Congratulations! You've Got Free Shipping";
        }else {
          let textMoney = freeshipping - cartTotal;
          textMoney = parseFloat(textMoney).toFixed(2);
          textMoney.toString();
          if(process.env.GATSBY_REGION_CODE == `uk`){
            helloText = "Only £"+textMoney+" Away From Free Shipping";
          }else{
            helloText = "Only $"+textMoney+" Away From Free Shipping";
          }
        }
        if (!helloText && notificationActive) {
          setNotificationActive(false);
        }

        return (
          <div>
          <div
            className={`notification ${
              notificationActive ? `active` : ``
            } w-full h-8 fixed top-0 right-0 left-0 z-30 flex items-center justify-center overflow-hidden bg-hit-pink text-black text-center`}
          >
            <button
              type="button"
              onClick={() => setNotificationActive(false)}
              className={`transition-opacity ${
                notificationActive ? `` : `opacity-0`
              } w-full h-full relative block`}
            >
              <span
                className={`${device === `desktop` ? `b2` : `caption`} block`}
              >
                {helloText}
              </span>
            </button>

            <div className="w-8 h-8 absolute top-0 right-0 bottom-0 pointer-events-none flex items-center justify-center">
              <Cross className="w-6" />
            </div>
          </div>
          <div
            className={`notification ${
              notificationActive ? `notification-active` : ``} ${
              freenoticeActive ? `active` : ``
            } w-full h-8 fixed top-0 right-0 left-0 z-30 flex items-center justify-center overflow-hidden bg-picasso text-black text-center`}
          >
            <button
              type="button"
              onClick={() => {setFreenoticeActive(false); setCartActive(true);}}
              className={`transition-opacity ${
                freenoticeActive ? `` : `opacity-0`
              } w-full h-full relative block`}
            >
              <span
                className={`${device === `desktop` ? `b2` : `caption`} block`}
              >
                A free Paire has been added to your cart!
              </span>
            </button>

            <div className="w-8 h-8 absolute top-0 right-0 bottom-0 pointer-events-none flex items-center justify-center">
              <Cross className="w-6" />
            </div>
          </div>
          </div>
        );
      }}
    />
  );
};

export default Notification;
